<div class="d-flex" style="height: 100%">
  <div id="country-map" [class.landingHeight]="landingPage">
    <div class="map-view-container" *ngIf="locationData.length > 0">
      <div class="mapLabel">Map Key</div>
      <img class="line-img" height="1px" src="./assets/images/Vector 157.svg" />
      <div class="d-flex">
        <img class="sub-img" width="18px" height="18px" src="./assets/images/Ellipse 41.svg" />
        <div class="sub-label">Branches</div>
      </div>
      <div class="d-flex">
        <img class="sub-img" width="20px" height="18px" src="./assets/images/DC.svg" />
        <div class="sub-label">Distribution Centers</div>
      </div>
      <div class="d-flex">
        <img class="sub-img" width="20px" height="18px" src="./assets/images/Rectangle 3808.svg" />
        <div class="sub-label">External Vendor</div>
      </div>
      <div class="d-flex">
        <img class="sub-img" width="20px" height="18px" src="./assets/images/Polygon 10.svg" />
        <div class="sub-label">Plants</div>
      </div>
    </div>
  </div>
</div>
